import { Fragment, ReactNode, useState } from "react"
import {
  FoodImageBox,
  Image,
  FoodImagePlaceholder,
  ImageBottomOverlay,
} from "./styled"
import largeMealPlaceholder from "assets/images/food-image-placeholder.png"
import ImagePreviewer from "./ImageViewer"


const FoodImage = ({
  previewImageUrl,
  children,
}: {
  previewImageUrl?: string
  children?: ReactNode
}) => {
  const [previewerVisible, setPreviewerVisible] = useState(false)
  const [hasError, setHasError] = useState(false)

  const hasImage = previewImageUrl && !hasError

  return (
    <FoodImageBox>
      {children}
      {hasImage ? (
        <Fragment>
          <Image
            onClick={() => {
              setPreviewerVisible(true)
            }}
            src={previewImageUrl ?? ""}
            alt="food-image"
            onError={() => setHasError(true)}
          />
          <ImageBottomOverlay />
        </Fragment>
      ) : (
        <Fragment>
          <FoodImagePlaceholder src={largeMealPlaceholder} />
        </Fragment>
      )}
      {hasImage && (
        <ImagePreviewer
          isOpen={previewerVisible}
          onClose={() => {
            setPreviewerVisible(false)
          }}
          imageUrl={previewImageUrl}
        />
      )}
    </FoodImageBox>
  )
}

export default FoodImage
